import styled from 'styled-components';
import tokens from '@fcc/tokens/dist/tokens.json';
import { Link } from '@fcc/ui';

export const Wrapper = styled.div`
    border-radius: ${tokens.border.radius.xl}px;
    padding: 81px 16px;
    background-color: ${tokens.color.primary.brand.white};
    text-align: center;
`;

export const CustomLink = styled(Link)`
    & span {
        text-decoration: none;
    }
`;
